/**
 * @generated SignedSource<<1f914bf71a4062c6c6de0a80bdae3fc3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ProductInput = {
  availableQuantity: number;
  barcode: string;
  description: string;
  imageUrl: string;
  name: string;
  price: number;
};
export type ProductModal_new_Mutation$variables = {
  data: ProductInput;
};
export type ProductModal_new_Mutation$data = {
  readonly createProduct: {
    readonly _id: string;
  };
};
export type ProductModal_new_Mutation = {
  response: ProductModal_new_Mutation$data;
  variables: ProductModal_new_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "ProductIdModel",
    "kind": "LinkedField",
    "name": "createProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductModal_new_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductModal_new_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f5421b96398e92844ce7d4f11ab8648",
    "id": null,
    "metadata": {},
    "name": "ProductModal_new_Mutation",
    "operationKind": "mutation",
    "text": "mutation ProductModal_new_Mutation(\n  $data: ProductInput!\n) {\n  createProduct(data: $data) {\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b035c9f3feba1123fffebec012e0c86c";

export default node;
